import React from 'react';
import Bootstrap from '../bootstrap';
import MicroComponent from '../common/MicroComponent';
import { StubbedImageData } from '../data/image-stubs';

const ImageGalleryModal: React.FC = () => {
  return (
    <Bootstrap>
      <MicroComponent
        micro={{ sdkName: SERVICE_SDK_NAME, componentName: 'ImageGalleryModal' }}
        images={StubbedImageData}
      />
    </Bootstrap>
  );
};

export default ImageGalleryModal;
